module.exports = __webpack_public_path__ + "static/media/Step-2.fd5c31b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/Step-2.jpg
// module id = 298
// module chunks = 0